import React from 'react';
import { connect } from 'react-redux';
import { PlansSelector } from '../../redux/reducers/PlansReducer';
import ContractCheckout from '../../components/checkout/Checkout/ContractCheckout';
import OpenTermCheckout from '../../components/checkout/Checkout/OpenTermCheckout';

const mapStateToProps = state => ({
  isContractSelected: PlansSelector.getIsContractSelected(state),
  isByoModemSelected: PlansSelector.getIsByoModemSelected(state)
});

const CheckoutContainer = connect(mapStateToProps)(
  props => props.isContractSelected
    ? <ContractCheckout isByoModemSelected={props.isByoModemSelected} />
    : <OpenTermCheckout isByoModemSelected={props.isByoModemSelected} />);

export default CheckoutContainer;



/** WEBPACK FOOTER **
 ** ./src/redux/containers/CheckoutContainer.js
 **/